module.exports = __webpack_public_path__ + "media/images/illustrations/home-405448311eab48ef923ee6ab1e8b782d.svg";